// extracted by mini-css-extract-plugin
module.exports = {"summaryError":"CalculatorResult_summaryError__hzVW1","summaryText":"CalculatorResult_summaryText__n7EjQ"};